var exports = {
  "AS": "xa15a2ab7--6bb009--item",
  "_8": "xa15a2ab7--6bb009--img",
  "Qq": "xa15a2ab7--6bb009--text",
};

module.exports = exports;
